<template>
  <BookForm
    :params="params"
    :result="result"
    :pack="pack"
    :category="category"
    :meal="meal"
    @back="onBack"
    @book="onBook"
    />
</template>

<script>
import model from './services/model'
import BookForm from './components/book_form'

export default {
  components: { BookForm },
  data () {
    const routeParams = this.$route.params
    const result = model.results.find(el => el.id.toString() === routeParams.Result.toString())

    const pack = result.packages.find(el => el.id.toString() === routeParams.Package.toString())
    const category = pack.categories.find(el => el.id.toString() === routeParams.Category.toString())
    const meal = category.meals[routeParams.Meal]

    return {
      params: model.params,
      result: result,
      pack: pack,
      category: category,
      meal: meal
    }
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Private/' + ((this.params.packageType === 'package') ? 'Package' : 'Tour') + '/Search' })
    },
    onBook (id) {
      this.$router.push({ name: 'Private/Bookings/View', params: { Id: id } })
    }
  }
}
</script>
